import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { withTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${props => props.theme.palette.primary.contrastText};
  background: ${props => props.theme.palette.primary.main};
  border-radius: 100px;
  padding: 4px 8px;
  font-size: 0.8em;
  font-weight: 500;
  margin: 2px 5px;
  height: 20px;
  line-height: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);
`;

const NavIcon = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 8px;
`;

const NavButton = styled(Button)`
  white-space: nowrap;
`;

const NavLink = ({
  link,
  icon,
  badge,
  badgePosition = 'right',
  external,
  size = 'small',
  children,
  theme,
  ...other
}) => (
  <ThemeProvider theme={theme}>
    <NavButton
      href={link.href}
      size={size}
      classes={{ label: 'label' }}
      target={external ? '_blank' : null}
      {...other}
    >
      {children ? (
        children
      ) : (
        <>
          {icon && <NavIcon alt="" src={icon.url} />}
          {badgePosition === 'right' && link.title}{' '}
          {badge && <Badge>{badge}</Badge>}{' '}
          {badgePosition === 'left' && link.title}
        </>
      )}
    </NavButton>
  </ThemeProvider>
);

export default withTheme()(NavLink);
